import styled, { css } from 'styled-components'

import { color, transition, shadow } from '../../style'

const { primary, secondary } = color

function createSize(size, outlined) {
  const height = new Map([
    ['default', 30],
    ['medium', 36],
    ['large', 40],
    ['gigant', 50],
  ]).get(size)
  return css`
    border-radius: ${height / 2}px;
    height: ${height}px;
    line-height: ${outlined ? height - 2 : height}px;
  `
}

const ButtonBase = css`
  cursor: pointer;
  text-decoration: none;
  padding: 0 1em;
  color: white;
  width: ${(p) => (p.block ? '100%' : p.width ? `${p.width}px` : 'auto')};
  position: relative;
  display: inline-block;
  text-align: center;
  touch-action: manipulation;
  white-space: nowrap;
  user-select: none;
  font-weight: bold;
  box-shadow: ${shadow[1]};
  :active,
  :focus {
    outline: 0;
  }
  :not([disabled]):active {
    box-shadow: none;
  }
  :disabled {
    pointer-events: none;
    filter: invert(0.8) grayscale(100%);
  }
`
export const ContainedButton = styled.button`
  ${ButtonBase};
  ${(p) => createSize(p.size)};
  border: none;
  background-size: 300% 100%;
  transition: ${transition(['background-position', 'box-shadow'])};
  background-image: linear-gradient(to right, ${primary}, ${secondary}, ${secondary}, ${primary});
  :hover {
    background-position: 100% 0;
    box-shadow: ${shadow[3]};
  }
`
export const OutlinedButton = styled.button`
  ${ButtonBase};
  ${(p) => createSize(p.size, true)};
  border: 2px solid ${primary};
  background-color: transparent;
  transition: ${transition(['background-color', 'box-shadow'])};
  :hover {
    box-shadow: ${shadow[3]};
    background-color: ${primary};
  }
`
